import {
  FormControlLabel,
  Switch,
  SwitchProps,
  TypographyProps,
} from '@mui/material';

export type ToggleSwitchProps = Omit<SwitchProps, 'size'> & {
  label: string;
  typographyProps?: TypographyProps;
};
export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  label,
  typographyProps,
  ...switchProps
}) => {
  return (
    <FormControlLabel
      control={<Switch {...switchProps} aria-label={label} />}
      label={label}
      slotProps={{
        typography: {
          noWrap: true,
          sx: { pl: 2 },
          ...typographyProps,
        },
      }}
    />
  );
};
